// extracted by mini-css-extract-plugin
export var root = "LWse";
export var rootIcon = "_1MJv";